/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {ElementRef, InjectionToken} from '@angular/core';

export const /** @type {?} */ POPOVER_HOST_ANCHOR = new InjectionToken<ElementRef>("POPOVER_HOST_ANCHOR");
